import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MeetingsPage } from "@/features/meetings/MeetingsPage";

const search = z.object({
  tab: z.enum(["upcoming", "past", "all"]).optional(),
  view: z.enum(["table", "cards"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/meetings/")({
  validateSearch: search,
  component: () => <MeetingsPage search={Route.useSearch()} />,
});
